import React, { ButtonHTMLAttributes, ReactNode } from 'react';

interface OwnProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children?: ReactNode;
}
const BasicButton = (props: OwnProps) => {
  const { children, ...restProps } = props;
  return (
    <button {...restProps}>{children}</button>
  );
};

export {
  BasicButton,
};

export type {
  OwnProps as BasicButtonProps,
}